module.exports = __webpack_public_path__ + "img/xk2.b929233a.png";